<template>
  <!-- 页面弹框  -->
  <div class="pagePop" ref="pagePop">
    <div class="pop">
      <div class="titleArea">
        <div class="title">
          {{ title || "提示" }}
        </div>
        <div class="close el-icon-close" @click="$emit('close')"></div>
      </div>
      <div class="content" :class="{isScrollStyle: isScroll}">
				<slot></slot>
      </div>
      <!-- <div class="bottom" ref="bottom">
        <span class="bt delete" @click="$emit('deleteAll')">清空</span>
        <span class="bt submit" @click="$emit('submit')">提交</span>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: ["title", "isScroll"],
  data() {
    return {
      isShowMore: false,
    };
  },
  computed: {},
  watch: {},
  methods: { 
  },
  components: {},
  mounted() {
    this.$nextTick(() => {
      document.body.appendChild(this.$refs.pagePop);
    });
  },
  beforeDestroy() {},
};
</script>
<style lang="less">
.isScrollStyle {
  overflow: scroll;
}
.pagePop {
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  .pop {
    width: 430px;
    // min-height: 400px;
    // height: 96%;
    background: #fff;
    border-radius: 3px;
    position: relative;
    overflow: hidden;
    .titleArea {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      border-bottom: 1px solid #dcdfe6;
      cursor: pointer;
      .close {
        &:hover {
          color: #3078ff;
        }
      }
    }
    .content {
      max-height: 500px;
      // margin-bottom: 50px;
    }
    .bottom {
      width: auto;
      justify-content: flex-end;
      .bt {
        // margin: 10px 10px 0;
        margin: 10px 0 0 10px;
      }
    }
    // .bottom {
    //   height: 50px;
    //   position: absolute;
    //   bottom: 0;
    //   display: flex;
    //   justify-content: flex-end;
    //   align-items: center;
    //   width: 100%;
    //   box-shadow: 0px -1px 8px #e3e3ed;
    //   background: #f5f5fc;
    //   .bt {
    //     margin-right: 15px;
    //     padding:0 15px;
    //   }
    //   .delete {
    //     background: #f56c6c;
    //     border-color: #f56c6c;
    //   }
    // }
  }
}
.info-pop-style {
  .pop {
    .content {
      // margin-bottom:10px !important;
      .user-center {
        .user-center-forms .el-input__inner {
          background: #fff;
        }
      }
      .flex-center {
        width: auto !important;
        justify-content: flex-end;
        .bt {
          // margin: 10px 10px 0;
        }
      }
    }
  }
}
.edit-pop-style {
  .pop{
    width: 520px;
    .content {
      margin-bottom: 20px !important;
    }
  }
}
.table-pop-style {
  .pop{
    width: 800px;
  }
}
.add-role-operate {
  .pop{
    width: auto;
    .content {
      margin-bottom:5px !important;
    }
  }
}
.system-pop-style {
  .pop{
    width: 835px;
    // height: 580px;
    .content {
      max-height: none !important;
      margin-bottom: 0 !important;
      .add-model-bottom { 
        position: absolute !important;
        bottom: 10px !important;
        width: 527px !important;
        .bt {
          margin-right: 0 !important;
        }
        .dry-run-bt {
          width: 100px;
        }
        .noAllow {
          cursor: not-allowed;
          background: #cdcdcd;
          border:1px solid #cdcdcd;
        }
      }
      .bin-json-editor {
        width: 430px;
      }
    }
  }
}
.api-pop-style {
  .pop{
    width: 800px;
     
  }
}
.upload-pop-style {
  .pop{
    width: 800px;
    height: 500px;
    .content {
      max-height: none !important;
      margin-bottom: 0 !important;
    }
  }
}
.add-role-permission {
  .pop{
    width: 600px; 
  }
}
.operator-pop-style {
  .flex-center {
    .bt {
      margin-left: 15px;
      margin-top: 0px !important;
    }
  }
}
</style>